import type { ReactNode } from 'react';

/**
 * STITCH-2 section shell primitive (design-language 03 P13; DESIGN DIRECTION
 * law (g)): white card with the letterspaced small-caps EYEBROW idiom (the
 * existing "SLA AND ESCALATION" treatment), a section title, optional sub
 * line and header actions, on soft elevation. Optional calm tint backdrops
 * for section/empty-state framing (law (c)).
 */
export interface SectionShellProps {
  readonly eyebrow?: string;
  readonly embedded?: boolean;
  readonly title: string;
  readonly sub?: ReactNode;
  readonly actions?: ReactNode;
  readonly tint?: 'teal' | 'sand' | 'mist';
  readonly children: ReactNode;
  readonly testId?: string;
}

export default function SectionShell({
  eyebrow,
  embedded = false,
  title,
  sub,
  actions,
  tint,
  children,
  testId,
}: SectionShellProps) {
  if (embedded) return (
    <section aria-label={title} data-testid={testId} className="ac-section__embedded">
      {actions ? <div className="ac-section__embedded-actions">{actions}</div> : null}
      {children}
    </section>
  );
  const cls = tint ? `ac-section ac-section--tint-${tint}` : 'ac-section';
  return (
    <section className={cls} data-testid={testId}>
      <div className="ac-section__head">
        <div>
          {eyebrow ? <p className="ac-section__eyebrow">{eyebrow}</p> : null}
          <h2 className="ac-section__title">{title}</h2>
          {sub ? <p className="ac-section__sub">{sub}</p> : null}
        </div>
        {actions ? <div>{actions}</div> : null}
      </div>
      {children}
    </section>
  );
}
